import { useAccountUsesRegEd, useRegEdMyUserMapQuery } from '@Queries/RegEdCompliance';
import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import regEdLogo from '../../../assets/logo_reged.png';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { IntegrationCard } from '../IntegrationCard';
import { styleSheet } from './styles';

interface IProps {
	styles?: StyleDeclarationValue[];
}

/** Self-service grid tile for RegEd user mapping — self-gating (renders only when the account uses RegEd). */
export const RegEdComplianceCard: React.FC<IProps> = ({ styles = [] }) => {
	const userSession = useUserSession();
	const impersonationContext = userSession.impersonationContext;
	const usesRegEd = useAccountUsesRegEd(impersonationContext);
	const { data: userMap } = useRegEdMyUserMapQuery({ impersonationContext, enabled: usesRegEd });
	const history = useHistory();

	if (!usesRegEd) {
		return null;
	}

	const isMapped = !!userMap?.regEdUserId;
	return (
		<IntegrationCard
			canManage={true}
			enabled={isMapped}
			icon={<img alt='RegEd' className={css(styleSheet.logo)} src={regEdLogo} />}
			onManageClicked={() => history.push('/integrations/reged')}
			styles={styles}
		/>
	);
};
